module.exports = __webpack_public_path__ + "static/media/female4.23c9dafe.png";